/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Onedrive_Ingest_Approval_DeniedInputs */

const es_components_onedrive_ingest_approval_denied = /** @type {(inputs: Components_Onedrive_Ingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesta de OneDrive denegada`)
};

const en_components_onedrive_ingest_approval_denied = /** @type {(inputs: Components_Onedrive_Ingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OneDrive ingestion denied`)
};

/**
* | output |
* | --- |
* | "OneDrive ingestion denied" |
*
* @param {Components_Onedrive_Ingest_Approval_DeniedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_onedrive_ingest_approval_denied = /** @type {((inputs?: Components_Onedrive_Ingest_Approval_DeniedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Onedrive_Ingest_Approval_DeniedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_onedrive_ingest_approval_denied(inputs)
	return en_components_onedrive_ingest_approval_denied(inputs)
});
export { components_onedrive_ingest_approval_denied as "components.onedrive_ingest_approval.denied" }